import { useParams } from "react-router-dom";
import ReportViewer from "./ReportViewer";

const TripDetailsReport = () => {
  const { tripId } = useParams<{ tripId: string }>();

  return (
    <ReportViewer
      reportPath="/All Reports/BNSF-Ride Trip Details"
      parameters={{
        TripID: tripId ?? "",
        // rc: keys are SSRS PDF device-info settings (passed through verbatim by the backend
        // URL-access builder) that override the RDL's portrait page setup without editing the
        // report-server definition.
        //
        // Goal: match the dashboard's single, full-width view. SSRS paginates PDF where the HTML
        // viewer just scrolls, so two things are tuned:
        //  - Width 17in with ZERO left/right margins: the body is slightly wider than the printable
        //    area at default margins, which makes SSRS emit a near-blank "overflow" page after each
        //    grid. Full-width printable area removes those blank pages.
        //  - A tall page so the stacked grids don't break vertically, approximating the dashboard's
        //    one continuous page.
        // NOTE: the report also emits ~3 structural trailing blank pages (explicit page breaks /
        // empty trailing sections in the RDL). Those are NOT affected by page size — confirmed they
        // persist even at a near-max 190in page — so they can only be removed at the source (RDL on
        // the SSRS server) or by trimming the PDF server-side after render.
        "rc:PageWidth": "17in",
        "rc:PageHeight": "44in",
        "rc:MarginLeft": "0in",
        "rc:MarginRight": "0in",
        "rc:MarginTop": "0.25in",
        "rc:MarginBottom": "0.25in",
      }}
      title={`BNSF Trip Details — Trip ${tripId ?? ""}`}
    />
  );
};

export default TripDetailsReport;
